import React from 'react';
import FieldViewer from './field-viewer';

const CompareAddress = ({modified, unmodified, title, mask}) => {
    
    return ( 
        <>
        {mask ? <>Not Shown</>:
        <div className="mb-2">
            <label className="text-xs">{title}</label>
            <p>
                
                <FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="addressLine1" /> <br /> 
                {modified?.addressLine2 || unmodified?.addressLine2 ? 
                    <><FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="addressLine2" /><br /></> 
                    : <></>}
                <FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="city" />,&nbsp;
                {
                    modified?.country === "US" ?
                    <FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="state" />
                    :
                    <FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="region" />
                }
                &nbsp;<FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="postalCode" />
                {
                    modified?.country !== "US"?
                    <><br />
                    <FieldViewer modifiedObj={modified} unmodifiedObj={unmodified} property="country" />
                    </>
                    :<></>
                }
                </p>
        </div>
                }
                </>
     );
}
 
export default CompareAddress;